import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { HeroSection } from '../components/HeroSection';
import { EmotionalIntro } from '../components/EmotionalIntro';
import { WhyReadSection } from '../components/WhyReadSection';
import { BookContents } from '../components/BookContents';
import { DiasporaSection } from '../components/DiasporaSection';
import { BookExcerpts } from '../components/BookExcerpts';
import { Testimonials } from '../components/Testimonials';
import { WhyNowSection } from '../components/WhyNowSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { RecentPurchaseNotification } from '../components/RecentPurchaseNotification';
export function LandingPage() {
  return <main className="w-full min-h-screen bg-[#0a0a0a] overflow-x-hidden" data-id="element-354">
      <AnnouncementBar data-id="element-355" />
      <HeroSection data-id="element-356" />
      <EmotionalIntro data-id="element-357" />
      <WhyReadSection data-id="element-358" />
      <BookContents data-id="element-359" />
      <DiasporaSection data-id="element-360" />
      <BookExcerpts data-id="element-361" />
      <Testimonials data-id="element-362" />
      <WhyNowSection data-id="element-363" />
      <FAQSection data-id="element-364" />
      <FinalCTA data-id="element-365" />
      <RecentPurchaseNotification data-id="element-366" />
    </main>;
}